import {
  CreateExchangeRangeModel,
  CreateExchangeRateCommand,
  ExchanegeRateService,
} from '@acme/api';
import { CryptoCurrencyEnum } from '@acme/api/admin';
import { exchangeRateFormConfig, useCryptoCurrency } from '@acme/domains';
import {
  Form,
  FormControls,
  useFormModel,
  type FormConfig,
} from '@acme/foundation';
import { Button, Card } from 'flowbite-react';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type RawModelType = {
  cryptoCurrencyId: CryptoCurrencyEnum;
  amount: number;
  expiresAt: string;
} & { [key in string]: string };

export const ExchangeRateForm = () => {
  const navigate = useNavigate();
  const { currencies } = useCryptoCurrency();
  const [ratesAmount, setRatesAmount] = useState<number>(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddNewRate = () => {
    setRatesAmount((prev) => prev + 1);
  };

  const formConfig = useMemo(() => {
    return exchangeRateFormConfig(
      true,
      currencies.map((i) => ({
        label: i.name ?? '',
        value: String(i.id ?? ''),
      }))
    );
  }, [currencies]);

  const form = useFormModel<RawModelType>({
    config: formConfig as unknown as FormConfig<RawModelType>,
    ctx: {} as RawModelType,
  });

  const onSubmit = async (m: RawModelType) => {
    const rates: CreateExchangeRangeModel[] = [];

    // todo тут логика поменялась

    // for (let i = 0; i < ratesAmount; i++) {
    //   rates.push({
    //     min: +m?.[`min-${i}`],
    //     max: +m?.[`max-${i}`],
    //     buyPrice: +m?.[`buyPrice-${i}`],
    //     sellPrice: +m?.[`sellPrice-${i}`],
    //   });
    // }

    const finalModel: CreateExchangeRateCommand = {
      amount: +m.amount,
      currencyId: +m.cryptoCurrencyId,
      expireAt: m.expiresAt,
      ranges: rates,
    };

    setIsSubmitting(true);
    try {
      const response = await ExchanegeRateService.postApiV1ExchanegeRateCreate({
        requestBody: finalModel,
      });

      if (response.isSuccess) {
        navigate('/rates');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form form={form} onSubmit={onSubmit} className="flex flex-col">
      <Card>
        <div className="grid grid-cols-4 gap-6">
          <FormControls form={form} />
        </div>

        <Button onClick={handleAddNewRate} color="primary">
          Добавить rates
        </Button>

        <Button type="submit" color="primary" disabled={isSubmitting}>
          {isSubmitting ? 'Отправка...' : 'Создать курс'}
        </Button>
      </Card>
    </Form>
  );
};
